module.exports = __webpack_public_path__ + "media/voiceOver_01.0e0dcb17.aac";